import React, { useRef, useEffect } from 'react';
import './modal.css';

function Modal({ children, open, onClose, title }: { title?: string, children: React.ReactNode, open: boolean, onClose: () => void }) {
  // const closeRef = useRef(null);
  const modalRef = useRef(null);
  useEffect(
    () => {
      window.addEventListener('click', function(event) {
        if (event.target === modalRef.current){
          onClose();
        }
      });
    },
    [onClose],
  );
  return (
    // <div id="myModal" ref={modalRef} className="modal" style={{ display: open ? 'block' : 'none' }}>
    //   <div className="modal-content">
    //     <span ref={closeRef} className="close" onClick={() => onClose()}>&times;</span>
    //     {children}
    //   </div>
    // </div>

    <>
      <div className={`modal fade ${open && 'show'}`} id="exampleModal" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ display: open ? 'block' : 'none' }}>
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">{title}</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => onClose()}>
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              {children}
            </div>
            <div className="modal-footer">
              {/* <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="button" className="btn btn-primary">Save changes</button> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Modal;

